import React from "react";
import AppSwitch from "../../../../components/AppSwitch";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const niceToKnowItems = [
  "Switches stehen für unmittelbare Ein/Aus-Zustände.",
  "Description ist optional.",
  "Error ersetzt die Description.",
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

function StateExample({ title, children }) {
  return (
    <div className="ds-docs-switch-preview__state">
      <div className="ds-docs-switch-preview__state-title">{title}</div>
      {children}
    </div>
  );
}

export default function SwitchesDocs() {
  return (
    <DocsSectionCard title="Switches">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-switch-preview">
            <PreviewRow label="Default">
              <AppSwitch
                label="Benachrichtigungen aktivieren"
                description="Neue Konflikte werden direkt nach der Berechnung gemeldet."
                defaultChecked
              />
            </PreviewRow>

            <PreviewRow label="Nur Label">
              <AppSwitch label="Raumkonflikte markieren" />
            </PreviewRow>

            <PreviewRow label="States">
              <div className="ds-docs-switch-preview__states">
                <StateExample title="Disabled">
                  <AppSwitch label="Export freigegeben" description="Momentan nicht verfügbar" checked disabled readOnly />
                </StateExample>

                <StateExample title="Error">
                  <AppSwitch label="Externe Sichtbarkeit" error="Bitte Einstellung prüfen." invalid />
                </StateExample>
              </div>
            </PreviewRow>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
